export interface AufgabenZeitpunkt {
  key: 'minuten' | 'stunden' | 'gestern' | 'tage';
  n?: number;
}

const MINUTE_MS = 60 * 1000;
const TAG_MS = 24 * 60 * MINUTE_MS;

function tagesbeginn(zeit: Date): number {
  return new Date(zeit.getFullYear(), zeit.getMonth(), zeit.getDate()).getTime();
}

export function aufgabenZeitpunkt(createdAt: string, jetzt: Date): AufgabenZeitpunkt {
  const erstellt = new Date(createdAt);
  const minuten = Math.floor((jetzt.getTime() - erstellt.getTime()) / MINUTE_MS);
  if (minuten < 60) return { key: 'minuten', n: Math.max(1, minuten) };
  const tage = Math.round((tagesbeginn(jetzt) - tagesbeginn(erstellt)) / TAG_MS);
  if (tage === 0) return { key: 'stunden', n: Math.floor(minuten / 60) };
  if (tage === 1) return { key: 'gestern' };
  return { key: 'tage', n: tage };
}
